import React from 'react'
import {
    createRegisterableComponentWithData,
    EditionLoader,
} from '@news-mono/web-common'
import { SpecialEdition, SpecialEditionProps } from './SpecialEdition'

export interface NightlySpecialEditionRegistrationV2Props {
    lazyloadImages?: boolean
    shouldShowAllEditions?: boolean
}

export const NightlySpecialEditionV2Registration =
    createRegisterableComponentWithData(
        'nightly-special-edition-v2',
        EditionLoader,

        (
            { ...props }: NightlySpecialEditionRegistrationV2Props,
            data,
            services,
        ) => {
            if (!data.loaded) return null

            const edition = data.result.documents?.[0]
            if (!edition) {
                services?.log?.error(data, 'NightlyLatestEdition: empty result')
                return null
            }

            // The title for "The Nightly On" editions is in the format "title_DD-MM-YYYY", this
            // removes the date part and normalizes the title to be capitalized.
            const normalizedEditionTitle = edition.title
                ? edition.title.split('_')[0].charAt(0).toUpperCase() +
                  edition.title.split('_')[0].slice(1).toLowerCase()
                : ''

            // Extract the year from edition.title formatted as title_DD-MM-YYYY
            const editionYear = edition.title.match(/\d{4}$/)?.[0] || ''

            if (!edition.primaryTopic) {
                services?.log?.error(
                    data,
                    'NightlyLatestEdition: missing primaryTopic',
                )
                return null
            }

            // Map edition properties to props
            const updatedProps: SpecialEditionProps = {
                ...props,
                title: `${normalizedEditionTitle} Edition ${editionYear}`,
                teaser: edition.teaser,
                link: edition.editionWebUrl,
                imageURL: edition.mainImages?.[0]?.src || '',
                lazyloadImages: props.lazyloadImages,
                shouldShowAllEditions: props.shouldShowAllEditions,
                alt: edition.mainImages?.[0]?.captionText || '',
                publicationDate: edition.publicationDate,
                path: edition.primaryTopic,
                onEvent: services.onEvent,
                editionId: edition.id,
            }
            return <SpecialEdition {...updatedProps} />
        },
    )
